





































import Vue from 'vue';
import StripeElement from './StripeElement.vue';
import { createPaymentMethod } from './stripe';

interface Data {
  nameOnCard: string,
  cardNoElement: object|null,
}

interface ChangeEvent {
  error?: {
    message: string,
  },
}

export default Vue.extend({
  components: {
    StripeElement,
  },
  data(): Data {
    return {
      nameOnCard: '',
      cardNoElement: null,
    };
  },
  methods: {
    createPaymentMethod(): Promise<string> {
      return createPaymentMethod(this.nameOnCard, this.cardNoElement);
    },
    onChange(event: ChangeEvent) {
      let error: string|null = null;
      if (event.error) {
        error = event.error.message;
      }
      this.$emit('error', error);
    },
  },
});
